import React, { useContext, useEffect, useRef, useState } from 'react'
import { Box, ModalClose } from '@mui/joy';
import { DataGridPro, gridFilteredDescendantCountLookupSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro'
import ListToolbar from './ListToolbar'
import { useDataProvider } from '../../../mtska-frontend-data-provider'
import { Text } from '../Typography'
import { Button } from '../Button'
import { useTranslation } from 'react-i18next'
import { BreadCrumb } from '../Drawer'
import { getCustomLocaleText, handleApplyRecipe, getColumnDefinition, getColumnRender } from './list.functions'
import { CustomFooter } from './customFooter/CustomFooter';
import { AppContext, useSettingContextInComponent, useSettingsContext } from 'src/mtska-frontend-app-scaffolding'
import { useCellModes, useFullScreen, useRows } from './list.hooks'
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import { IconButton } from 'src/mtska-frontend-app-component/assets';
import ColumnsPanel from './ColumnsPanel';
import FiltersPanel from './FiltersPanel';

const listId = Math.random().toString(16).slice(2);

const pageSizeOptions = [5, 10, 15, 20, 100, 250, 500];

const List = (props) => {

    const {
        removeSaveButton = false,
        title,
        apiRef,
        uid,
        handleClose,
        dataProviderName,

        isDrawer, // se è drawer non deve salvare cambi di filtro, sort, ordine colonne, pin in settings
        isEmbedded, // se è embedded non deve salvare cambi di filtro, sort, ordine colonne, pin in settings

        enableSelection,
        defaultSelectedValues,
        disableMultipleRowSelection,
        rowSelectionExternalListener,
        maxRowSelection,
        selected,
        selectionModel,
        onRowSelectionModelChange = () => { },


        leftButtons = [],
        rightButtons = [],
        className = "",
        detailStack,
        onFilterPageSortChange: onGetFreshData = () => { },
        items,
        total,
        totalLabel,
        loading,
        onRowDoubleClick = () => { },
        doAction = () => { },
        doMassiveAction,
        headerFilters = true,
        mainButtonLabel = 'Save',
        intent,
        relation,
        treeData = false,
        customHeader = false,
        disableColumnSort = false,
        disableColumnFilter = false,
        hideTableFooter = false,
        hideTableToolbar = false,
        columnsNeeded, // array di colonne da visualizzare in override di settings e tableconfig

        // se non drawer o embedded, defaultFilters si aggiunge ai filtri dai settings,
        // se drawer o embedded, defaultFilters contiene gli unici filtri applicabili
        filters: defaultFilters = { items: [] },
    } = props


    // -------------
    // INIZIO ROBA BUONA
    // -------------
    const elementId = 'dataGridProContainerId'
    const { t } = useTranslation()
    const { item: config } = useDataProvider('configs/config');
    const { appConfiguration, innerHeight } = useContext(AppContext);

    const { settings, settingsLoaded, setSettingsKey, replaceFilters, comparableFilters, addKeyToFilterModel } = useSettingsContext(dataProviderName);
    //console.info('-0--CHIEDO CON ESTREMA GENTILEZZA DI OTTENERE FILTER MODEL A PARTIRE DA',dataProviderName, defaultFilters)
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localFilterModel, setLocalFilterModel] = useState();
    const [localPaginationModel, setLocalPaginationModel] = useState();
    const [localSortModel, setLocalSortModel] = useState();
    const [localRowSelectionModel, setLocalRowSelectionModel] = useState();
    const previousLocalFilterModelRef = useRef();
    const previousLocalPaginationModelRef = useRef();
    const previousLocalSortModelRef = useRef();
    const previousLocalRowSelectionModelRef = useRef();
    const previousQuickFilterValueRef = useRef();

    const { rowHeight } = appConfiguration || {};
    const { cellModesModel, handleCellClick, handleCellModesModelChange } = useCellModes();
    const { processRowUpdate, rows } = useRows({ config, dataProviderName, doAction, items });

    const [orderedColumns, setOrderedColumns] = useState([]);
    const [viewedItems, setViewedItems] = useState([]);
    const [isManaged, setIsManaged] = useState(isDrawer || isEmbedded);
    const [isInitialized, setIsInitialized] = useState(false);
    const [isFullScreen, setIsFullScreen ] = useState(false);

    // -------------
    // GESTIONE DELLA RICEZIONE STATI IN PARTENZA
    // -------------
    useEffect(() => {
        if (!settings || !settingsLoaded) return;

        const columns = getColumnRender(settings, config, dataProviderName, t, detailStack, processRowUpdate);

        const orderedColumns = (columnsNeeded || settings.columnOrder || []).map((colId) =>
            columns.find((column) => column.field === colId)
        ).filter(Boolean)

        if (isManaged) {
            setLocalPaginationModel({ "page": 0, "pageSize": 10 })
        } else {
            setLocalPaginationModel(settings.paginationModel)
        }

        setOrderedColumns(orderedColumns);
    }, [settings, settingsLoaded]);

    useEffect(() => {
        if (!filterModel) return;
        //console.info('-5--OTTENGO COME RISULTATO IL CORTESE',filterModel, "A PARTIRE DAGLI ESIMI",dataProviderName, defaultFilters)
        setLocalFilterModel(addKeyToFilterModel(filterModel));
    }, [filterModel]);

    useEffect(() => {
        if (!enableSelection) {
            return;
        }

        if (Array.isArray(selectionModel)) {
            setLocalRowSelectionModel(selectionModel);
            return;
        }

        if (Array.isArray(defaultSelectedValues)) {
            const tmp = defaultSelectedValues.reduce((a, v) => ({ ...a, [v.id]: v }), {});
            setViewedItems(tmp);

            const selectedItemsIds = defaultSelectedValues.map(el => el._id);
            setLocalRowSelectionModel(selectedItemsIds);
            return;
        }

        setLocalRowSelectionModel([]);

    }, [defaultSelectedValues, selectionModel, enableSelection]);

    // -------------
    // GESTIONE DEL CAMBIO DI STATI
    // -------------
    useEffect(() => {
        if (JSON.stringify(previousLocalFilterModelRef.current) !== JSON.stringify(localFilterModel)) {
            previousLocalFilterModelRef.current = localFilterModel;

            if (!isManaged && isInitialized) {
                // se siamo in una lista di base, qualsiasi modifica deve essere salvata in preferenze utente
                replaceFilters(localFilterModel);
            }

            const filterPageSort = { ...settings, sortModel: localSortModel, filterModel: localFilterModel, paginationModel: localPaginationModel }
            onGetFreshData(filterPageSort);
        }

        if (!isInitialized && localFilterModel) {
            setIsInitialized(true);
        }
    }, [localFilterModel]);

    useEffect(() => {
        if (JSON.stringify(previousLocalPaginationModelRef.current) !== JSON.stringify(localPaginationModel)) {
            previousLocalPaginationModelRef.current = localPaginationModel;

            if (!isManaged && isInitialized) {
                setSettingsKey('paginationModel', localPaginationModel);
            };

            const filterPageSort = { ...settings, sortModel: localSortModel, filterModel: localFilterModel, paginationModel: localPaginationModel }
            onGetFreshData(filterPageSort);
        }
    }, [localPaginationModel]);

    useEffect(() => {
        if (JSON.stringify(previousLocalSortModelRef.current) !== JSON.stringify(localSortModel)) {
            previousLocalSortModelRef.current = localSortModel;

            if (!isManaged && isInitialized) {
                setSettingsKey('sortModel', localSortModel);
            };

            const filterPageSort = { ...settings, sortModel: localSortModel, filterModel: localFilterModel, paginationModel: localPaginationModel }
            onGetFreshData(filterPageSort);
        }
    }, [localSortModel]);

    useEffect(() => {
        if (JSON.stringify(previousLocalRowSelectionModelRef.current) !== JSON.stringify(localRowSelectionModel)) {
            previousLocalRowSelectionModelRef.current = localRowSelectionModel;

            rowSelectionExternalListener && rowSelectionExternalListener(localRowSelectionModel)
            onRowSelectionModelChange && onRowSelectionModelChange(localRowSelectionModel)
        }
    }, [localRowSelectionModel]);


    const slots = {
        footer: !hideTableFooter && CustomFooter,
        toolbar: !hideTableToolbar && ListToolbar,
        columnsPanel: ColumnsPanel,
        filterPanel: FiltersPanel
    }

    // Some API clients return undefined while loading
    // Following lines are here to prevent `rowCount` from being undefined during the loading
    const rowCountRef = React.useRef(total || 0);

    const rowCount = React.useMemo(() => {
        if (total !== undefined) {
            rowCountRef.current = total;
        }
        return rowCountRef.current;
    }, [total]);

    // -------------
    // FINE ROBA BUONA
    // -------------

    // *******************************************************************
    // MANAGE ROW SELECTION & ASSOCIATION
    // *******************************************************************


    const localHandleSubmit = () => {
        if (!localRowSelectionModel && !selected) return;

        if (intent === 'relationshipManagement' && relation && Array.isArray(localRowSelectionModel) && localRowSelectionModel.length > 0) {

            // console.info('localHandleSubmit', relation);

            // creo la relazione tra papà e figli selezionati
            relation.doAction && relation.doAction({
                action: 'relationshipAssociation',
                model: relation.dataProviderName,
                data: {
                    relationName: relation.name,
                    parentId: relation.parentItemID,
                    childrenId: localRowSelectionModel,
                }
            }).then(() => {
                // console.info('relationshipAssociation completed')
                handleClose(uid, localRowSelectionModel)
            });
        } else {
            // questa non so cosa faccia
            const selectedItems = localRowSelectionModel ? localRowSelectionModel.map(id => viewedItems[id]).filter(item => item) : selected
            const callback = () => handleClose(uid, selectedItems)
            doMassiveAction ? doMassiveAction({ callback, selectedItems }) : callback()
        }
    }


    // forza display: 'none' a Checkbox selection 
    useEffect(() => {
        const observer = new MutationObserver(() => {
            document.querySelectorAll('.MuiFormControlLabel-root').forEach((el) => {
                if (el.textContent?.includes('Checkbox selection')) {
                    el.style.display = 'none'
                }
            })
        })
        observer.observe(document.body, { childList: true, subtree: true })
        return () => observer.disconnect()
    }, []);


    return !config?.data?.modules[dataProviderName]?.tableConfig ? (<>
        No tableConfig received for module '{dataProviderName}'!<br />
        Check server side config_modules configuration!
    </>) : (<>
        {isDrawer && (
            <>
                <Box className="drawer-section-header" >
                    <ModalClose />
                    <Text level="title-md" icon >{title}</Text>
                    {!removeSaveButton && (<Button label={t(mainButtonLabel)} className="button-main" onClick={localHandleSubmit} />)}
                </Box>
                <BreadCrumb />
            </>
        )}

        {drawable && (
            <Box
                className={isEmbedded ? className + " form-element" : "drawer-section-content" }
                id={elementId}
            >
                <Box className={(className + " list-system listy-system-" + listId + (isFullScreen ? " list-system-fullscreen" : "")).trim()}>
                    {/* 
                    <JSONPretty data={localPaginationModel} className='json-wrapper' />
                    <JSONPretty data={localFilterModel} className='json-wrapper' /> 
                    <JSONPretty data={config?.data?.modules[dataProviderName]?.tableConfig} className='json-wrapper' />
                    */}
                    
                    <DataGridPro
                        cellModesModel={cellModesModel}
                        onCellClick={handleCellClick}
                        onCellModesModelChange={handleCellModesModelChange}
                        processRowUpdate={processRowUpdate}
                        rows={rows || []}

                        apiRef={apiRef}
                        columns={orderedColumns}

                        filterModel={localFilterModel}
                        columnVisibilityModel={settings?.visibilityModel}
                        paginationModel={localPaginationModel}
                        rowSelectionModel={localRowSelectionModel}

                        onColumnVisibilityModelChange={(visibilityModel) => {
                            if (isManaged) return;
                            //console.info('>>>> ListComponent:onColumnVisibilityModelChange chiamo setSettingsKey', visibilityModel, Date.now())
                            setSettingsKey('visibilityModel', { ...visibilityModel, __check__: true })
                        }}
                        onColumnOrderChange={(columnSwapInstructions) => {
                            if (isManaged) return;
                            const { oldIndex, targetIndex } = columnSwapInstructions;
                            const ordere = orderedColumns;
                            const newColumnOrder = [...settings.columnOrder];
                            //console.info('COL ORDER IN PARTENZA', [...newColumnOrder])
                            if (oldIndex >= 0 && oldIndex < newColumnOrder.length &&
                                targetIndex >= 0 && targetIndex < newColumnOrder.length) {

                                const element = newColumnOrder.splice(oldIndex - 1, 1)[0];
                                newColumnOrder.splice(targetIndex - 1, 0, element);
                                //console.info('COL ORDER IN ARRIVO', [...newColumnOrder])
                                // console.info('>>>> ListComponent:onColumnOrderChange chiamo setSettingsKey', newColumnOrder, Date.now())
                                setSettingsKey('columnOrder', newColumnOrder);
                            }
                        }}
                        onFilterModelChange={(newFilterModel, details) => {
                            // accettiamo solo input utente, non fasi di inizializzazione
                            const quickFilterValue = newFilterModel?.quickFilterValues?.[0] ?? null;
                            if (!['deleteFilterItem', 'upsertFilterItem'].includes(details.reason) && quickFilterValue == previousQuickFilterValueRef.current) return;

                            previousQuickFilterValueRef.current = quickFilterValue;

                            // Debounce per digitazione utente
                            clearTimeout(window.filterDebounceTimer);

                            window.filterDebounceTimer = setTimeout(() => {
                                const _filtersNow = comparableFilters(localFilterModel);
                                const _filtersIncoming = comparableFilters(newFilterModel);

                                if (JSON.stringify(_filtersNow) != JSON.stringify(_filtersIncoming)) {
                                    //console.info('>>>> ListComponent:onFilterModelChange chiamo handleLocalFilterModelChange con argomento', newFilterModel, 'filtri veri', localFilterModel, 'details', details, Date.now())
                                    setLocalFilterModel(addKeyToFilterModel(newFilterModel));
                                }
                            }, 1000);
                        }}
                        onPinnedColumnsChange={(pinnedColumns) => {
                            if (isManaged) return;
                            //console.info('>>>> ListComponent:onPinnedColumnsChange chiamo setSettingsKey con argomento ', pinnedColumns, Date.now())
                            setSettingsKey('pinnedColumns', pinnedColumns);
                        }}
                        onSortModelChange={(sortModel) => {
                            setLocalSortModel(sortModel);
                        }}
                        onRowSelectionModelChange={(newRowSelectionModel) => {
                            const selectionModel = maxRowSelection ? newRowSelectionModel.slice(-maxRowSelection) : newRowSelectionModel
                            setLocalRowSelectionModel(selectionModel)
                        }}

                        slots={slots}
                        slotProps={{
                            toolbar: {
                                leftButtons,
                                rightButtons,
                                isFullScreen,
                                setIsFullScreen,
                                dataProviderName,
                                handleApplyRecipe,
                                total: customHeader ? total : undefined,
                                totalLabel,
                                apiRef,
                                setSettingsKey,
                                isManaged
                            },
                            footer: {
                                onPaginationModelChange: (paginationModel) => {
                                    setLocalPaginationModel(paginationModel);
                                },
                                pageSizeOptions,
                                paginationModel: localPaginationModel,
                                rowCount
                            },
                            filterPanel: {
                                dataProviderName,
                                columns: getColumnDefinition(settings, config, dataProviderName, t)
                            },
                            columnsPanel: {
                                dataProviderName,
                                columns: getColumnDefinition(settings, config, dataProviderName, t)
                            }
                        }}

                        treeData={treeData}
                        getTreeDataPath={(row) => row.hierarchy}
                        groupingColDef={{
                            headerName: 'Similar',
                            renderCell: (params) => <CustomGridTreeDataGroupingCell {...params} />,
                        }}

                        disableRowSelectionOnClick
                        disableColumnSort={disableColumnSort}
                        disableColumnFilter={disableColumnFilter}
                        disableMultipleRowSelection={disableMultipleRowSelection}

                        checkboxSelection={enableSelection}

                        getRowId={(row) => row._id}
                        pagination
                        paginationMode="server"
                        rowsPerPage={10}
                        loading={loading}
                        rowCount={rowCount}
                        rowHeight={rowHeight && rowHeight}
                        hideFooter={hideTableFooter}
                        filterMode="server"
                        sortingMode="server"
                        keepNonExistentRowsSelected
                        // onRowClick={onRowDoubleClick}
                        onRowDoubleClick={onRowDoubleClick}
                        className={"list-wrapper list-wrapper-" + listId}
                        headerFilters={headerFilters}
                        localeText={getCustomLocaleText({ t })}

                        //autoHeight={true}
                        sx={isFullScreen && !isManaged
                            ? {
                                '& .MuiDataGrid-virtualScroller': {
                                    overflow: 'auto'
                                }
                            }
                            : 
                            {}
                        }
                    />

                </Box>
            </Box>
        )}
    </>
    )
}

export default List


const CustomGridTreeDataGroupingCell = (props) => {
    const { id, field, rowNode } = props;
    const apiRef = useGridApiContext();
    const filteredDescendantCountLookup = useGridSelector(
        apiRef,
        gridFilteredDescendantCountLookupSelector,
    );
    const filteredDescendantCount = filteredDescendantCountLookup[rowNode.id] ?? 0;

    const handleClick = (event) => {
        if (rowNode.type !== 'group') {
            return;
        }

        apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
        apiRef.current.setCellFocus(id, field);
        event.stopPropagation();
    };

    return (
        <Box sx={{ ml: rowNode.depth * 4 }}>
            <div>
                {filteredDescendantCount > 0 ? (
                    <> <IconButton icon={rowNode.childrenExpanded ? "faMinus" : "faPlus"} onClick={handleClick} tabIndex={-1} size="small">

                    </IconButton> {filteredDescendantCount} similar</>
                ) : (
                    <span />
                )}
            </div>
        </Box>
    );
}

const Rumenta = () => {

    //const { copied, onCopy } = useCopiedRows({ rows, localRowSelectionModel })

    const newRightButtons = [
        //...rightButtons,
        // (localRowSelectionModel || []).length > 0 && <Button
        //     icon={copied ? 'faCheck' : 'faCopy'}
        //     label={copied ? t('Copiato') : t('Copia')}
        //     onClick={onCopy}
        //     variant='outlined'
        // />
    ]



    // add items to viewedItems when age or search change.. to have the full row object available for association
    // useEffect(() => {
    //     if (!Array.isArray(items)) return;
    //     //console.info("update viewedItems - items", items);
    //     const tmp = {
    //         ...viewedItems, ...items.reduce((a, v) => {
    //             //console.info("update viewedItems", v);
    //             return { ...a, [v.id]: v }
    //         }, {})
    //     };
    //     setViewedItems(tmp);
    // }, [items]);


    // PROPS DI DATAGRID
    // isRowSelectable={(params) => {
    //     console.log("isRowSelectable", params);
    //     if (params?.row?._original_id) {
    //         return false;
    //     }
    //     return true
    // }}
    // getRowClassName={(params) => {
    //     console.log("getRowClassName", params);

    //     if (params?.row?._original_id) {
    //         return 'similar-row';
    //     }

    //     return '';
    //   }}

    //         localFilterModel in List CMP
    // <JSONPretty data={localFilterModel} className="json-wrapper" style={{ overflow: 'scroll', fontSize: '10px' }}></JSONPretty>

    // <Box onClick={() => {
    //     setLocalFilterModel(addKeyToFilterModel({
    //         items: [
    //             {
    //                 "field": "registered_at",
    //                 "operator": "between",
    //                 "value": { from: '2025-01-01', to: '2025-12-31' }
    //             },
    //             {
    //                 "field": "_related_area_name",
    //                 "operator": "equals",
    //                 "value": 'Venezia'
    //             },
    //             {
    //                 "field": "_related_source_name",
    //                 "operator": "equals",
    //                 "value": 'Immobiliare'
    //             },
    //             {
    //                 "field": "budgetType",
    //                 "operator": "is",
    //                 "value": 'Centrale'
    //             }
    //         ]
    //     }))
    // }}>SCHIANTA FILTRI ORIGINALI</Box>

    // <Box onClick={() => {
    //     setLocalFilterModel(addKeyToFilterModel({
    //         items: [
    //             {
    //                 "field": "registered_at",
    //                 "operator": "between",
    //                 "value": { from: '2025-03-09', to: '2025-11-14' }
    //             },
    //             {
    //                 "field": "_related_area_name",
    //                 "operator": "equals",
    //                 "value": 'Treviso'
    //             },
    //             {
    //                 "field": "_related_source_name",
    //                 "operator": "equals",
    //                 "value": 'Idealista'
    //             },
    //             {
    //                 "field": "budgetType",
    //                 "operator": "is",
    //                 "value": 'Locale'
    //             }
    //         ]
    //     }))
    // }}>SCHIANTA FILTRI</Box>

    // <Box onClick={() => {
    //     setLocalFilterModel(addKeyToFilterModel({
    //         items: [
    //             {
    //                 "field": "registered_at",
    //                 "operator": "between",
    //                 "value": { from: '2025-02-09', to: '2025-08-01' }
    //             },
    //             {
    //                 "field": "_related_area_name",
    //                 "operator": "equals",
    //                 "value": 'Colline del Prosecco'
    //             },
    //             {
    //                 "field": "_related_source_name",
    //                 "operator": "equals",
    //                 "value": 'Landing Page'
    //             }
    //         ]
    //     }))
    // }}>SCHIANTA ALTRI FILTRI</Box>

}